<div *ngIf="dialog.items.length" data-test-id="modal-activities">
  <div class="modal-header">
    <h4 class="modal-title word-break" data-test-id="modal-title-activities">
      {{ dialog.items[0].entity.name }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-activities-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>

  <div class="modal-body" data-test-id="wrap-activities">
    <div class="d-flex" data-test-id="modal-title-activities-event">
      <div data-test-id="modal-title-activities-total-count">
        {{ totalCount }}
        {{ 'EVENT' | translate }}
      </div>
      <div class="ms-5" data-test-id="modal-title-activities-total-download-count">
        <img alt="image download" height="15" src="assets/icons/icon-download.svg" width="15" />
        {{ totalDownloadCount }}
      </div>
    </div>
    <dx-data-grid
      id="gridContainer"
      [dataSource]="activitiesDataSource"
      [showColumnHeaders]="false"
      [remoteOperations]="true"
      [showBorders]="false"
    >
      <dxo-paging [enabled]="true" [pageSize]="ACTIVITIES_PAGE_LIMIT"></dxo-paging>
      <dxo-scrolling mode="infinite"></dxo-scrolling>

      <dxi-column cellTemplate="cellTemplate" dataField="event_payload.file_view" [allowSorting]="false"></dxi-column>

      <div *dxTemplate="let data of 'cellTemplate'" class="white-space-n">
        <div class="d-flex align-items-center">
          <div class="flex-column" [attr.data-test-id]="'wrap-activities-avatar'">
            <app-small-profile-image
              [profileImage]="data.value.ownerItem.image_url"
              [accountStatus]="data.value.ownerItem.account_status"
              [dataTestId]="'activities-avatar'"
              [link]="getLink(data.value.ownerItem)"
            ></app-small-profile-image>
          </div>
          <div class="ms-2">
            <div
              *ngIf="ACTIVITIES_FILES_UPLOADED_EVENT === data.value.event"
              [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
              class="flex-column ps-1 w-100 word-break"
            >
              <app-activities-uploaded
                [activeUserId]="activeUserId$ | async"
                [data]="data"
                [isDialog]="true"
                (submit)="submit()"
              >
              </app-activities-uploaded>
            </div>

            <div
              *ngIf="ACTIVITIES_FILES_SHARED === data.value.event"
              [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
              class="flex-column ps-1 w-100 word-break"
            >
              <app-activities-shared
                [activeUserId]="activeUserId$ | async"
                [data]="data"
                [isDialog]="true"
                (submit)="submit()"
              ></app-activities-shared>
            </div>
            <div
              *ngIf="ACTIVITIES_FILES_UNSHARED === data.value.event"
              [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
              class="flex-column ps-1 w-100 word-break"
            >
              <app-activities-unshared
                [activeUserId]="activeUserId$ | async"
                [data]="data"
                [isDialog]="true"
                (submit)="submit()"
              ></app-activities-unshared>
            </div>
            <div
              *ngIf="ACTIVITIES_FILES_PERMISSION === data.value.event"
              [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
              class="flex-column ps-1 w-100 word-break"
            >
              <app-activities-permission
                [activeUserId]="activeUserId$ | async"
                [data]="data"
                [isDialog]="true"
                (submit)="submit()"
              ></app-activities-permission>
            </div>
            <div
              *ngIf="ACTIVITIES_FILES_DOWNLOADED === data.value.event"
              [attr.data-test-id]="'wrap-activities-text-' + data.value.entity_id"
              class="flex-column ps-1 w-100 word-break"
            >
              <app-activities-downloaded
                [activeUserId]="activeUserId$ | async"
                [data]="data"
                [isDialog]="true"
                (submit)="submit()"
              ></app-activities-downloaded>
            </div>
          </div>
        </div>
        <div class="pt-1 fw-light" [attr.data-test-id]="'wrap-activities-days-from-now-' + data.value.entity_id">
          {{ data.value.daysFromNow }} {{ 'DAYS_AGO' | translate }}
        </div>
      </div>
    </dx-data-grid>
  </div>

  <div class="modal-footer" data-test-id="modal-activities-footer">
    <button
      *ngFor="let button of dialog.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      aria-label="Close"
      [ngClass]="button.class"
      type="button"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'message-activities-dialog-btn-' + i"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>

<div *ngIf="!dialog.items.length" data-test-id="modal-activities">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title-activities-no-data">
      {{ 'NO_ACTIVITY' | translate }}
    </h4>
  </div>

  <div class="modal-footer" data-test-id="modal-activities-footer">
    <button
      *ngFor="let button of dialog.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      aria-label="Close"
      type="button"
      [ngClass]="button.class"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'message-activities-dialog-btn-' + i"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>
